<template>
  <v-select
    :name="name"
    :value="optionSelected"
    :options="optionsList"
    :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
    :disabled="isDisabled"
    :clearable="clearable"
    :placeholder="computedPlaceholder"
    :selectable="opt => !opt.disabled"
    @input="onInput"
  >
    <template #spinner>
      <b-spinner
        small
        v-if="nationalityState.loading"
        variant="primary"
      />
    </template>
    <template slot="no-options">
      No hay opciones para el criterio de búsqueda
    </template>
  </v-select>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VSelectNationality',
  computed: {
    ...mapGetters('List', [
      'nationalityState'
    ]),
    computedPlaceholder() {
      return this.nationalityState.loading ? 'Cargando opciones...' : this.placeholder;
    },
    optionSelected() {
      return this.optionsList.find((option) => option.value === this.value);
    },
    optionsList() {
      return this.nationalityState.list.map((opt) => ({
        value: opt.value,
        label: opt.label,
        disabled: false
      }));
    },
    isDisabled() {
      return this.disabled
        || !this.optionsList.length
        || this.nationalityState.loading;
    },
  },
  methods: {
    ...mapActions('List', [
      'fetchNationality'
    ]),
    onInput(event) {
      this.$emit('full-group', event);
      this.$emit('input', event?.value);
    },
  },
  created() {
    if (this.parent[`_fetch-${this.$vnode.tag}`]) return;
    this.fetchNationality().then(() => {
      if (this.parent) this.parent[`_fetch-${this.$vnode.tag}`] = true;
    });
  },
  props: {
    parent: { type: Object, required: true },

    name: { type: String, required: true },
    danger: { type: Boolean },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Por favor, seleccione una opción' },
    value: { type: String },
  }
};
</script>
